<app-pat-payment-panel-stripe-generic
  type="STRIPE_APPLE_PAY"
  [isPayButtonVisible]="false"
></app-pat-payment-panel-stripe-generic>
